<template>
  <div class="pop">
    <div class="bg-in">
      <img
        src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/na8sf2qdwqoppuzmgwaxkawnp9q9ot28pgeMsg.png"
        style="max-width: 90vw; height: auto; border-radius: 10px"
        @click="goToPromotion"
      >
      <div class="cancel-btn" @click="close">
        <img :src="cancelWhite" alt="cancel">
      </div>
    </div>
  </div>
</template>

<script>
import cancelWhite from '@/assets/images/common/cancelWhite.svg'

export default {
  name: 'InnerMsgPop',
  props: ['handleClose'],
  data () {
    return {
      cancelWhite,
      iFrameSrc: '',
      showPromotion: false,
      internation: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      delayedAWhile: false
    }
  },
  watch: {
  },
  components: {
  },
  mounted () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      let that = this
      setTimeout(() => {
        that.delayedAWhile = true
        return null
      }, 500)
    },
    close () {
      this.handleClose()
    },
    goToPromotion () {
      localStorage.setItem('pop11ban', true)
      this.close()
      this.$router.push('/Message')
    }
  }
}
</script>

<style lang="less" scoped>
  .pop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.6);
    z-index: 9;
    padding: 40px 20px;
    box-sizing: border-box;
    overflow: auto;

    .bg-in {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50.05%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 96vw;

      .cancel-btn {
        width: 28px;
        height: 28px;
        margin-top: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/InnerMsgPop/index.vue